var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-dollar","titulo":"PAGAMENTOS GESCON","subTitulo":"APOIO","qtd":_vm.qtd,"mostrarQtd":false,"loading":_vm.loading},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'Gescon_Apoios_Pagamentos' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }